export default (t) => [
  {
    text: t('Category Name'),
    value: 'name',
    sortable: true,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 120,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 150
  },
];
